<template>
  <div>
    <div>
      <h1>产品应用</h1>
      <div>
        <div class="top">
          <el-button
            type="primary"
            plain
            :class="this.flag === 0?'product-select':'product'"
            @click="onShow(0)"
            autofocus
          >
            <div class="msg">半导体显示智<br />能装备</div>
          </el-button>
          <el-button type="primary" plain :class="this.flag === 1?'product-select':'product'" @click="onShow(1)">
            <div class="msg">小尺寸显示面<br />板生产设备</div></el-button
          >
          <el-button type="primary" plain :class="this.flag === 2?'product-select':'product'" @click="onShow(2)">
            <div class="msg">MEMS传感器<br />智能装备</div>
          </el-button>
        </div>
        <div class="top">
          <el-button type="primary" plain :class="this.flag === 3?'product-select':'product'" @click="onShow(3)">
            <div class="msg">智能工厂系统<br />解决方案</div></el-button
          >
          <el-button type="primary" plain :class="this.flag === 4?'product-select':'product'" @click="onShow(4)">
            <div class="msg">其它智能制造<br />生产设备</div></el-button
          >
          <el-button type="primary" plain :class="this.flag === 5?'product-select':'product'" @click="onShow(5)">
            <div class="msg1">工装/治具</div></el-button
          >
          <div></div>
        </div>
      </div>
      <div>
        <div>
          <!-- 图片使用后期api url -->
          <el-image
            style="width: 43.875rem; height: 27.75rem; margin: 2.5rem 1.5rem"
            :src="categoryList[this.flag].cover"
            fit="contain"
          ></el-image>
          <div class="font1">{{ this.categoryList[this.flag].name }}</div>
          <div class="font2">{{ this.categoryList[this.flag].desc }}</div>
        </div>
      </div>
      <div style="text-decoration: none">
        <div class="font3" @click="toLinkServices">查看详情</div>
      </div>
      <router-link to="/contact/contactEngineer">
        <div class="font4">
          <div
            class="iconfont icon-contact"
            style="font-size: 2.353125rem; color: #0099da"
          ></div>
          <div class="font5">联系工程师</div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'product',
  props: {
    categoryList: {
      default: [{
          cover: '',
          name: '',
          desc: '',
      }],
      type: Array
    }
  },
  data () {
    return {
      showNub: 1,
      flag: 0,
    }
  },
  methods: {
    toLinkServices() {
        this.$router.push({
            path: '/services/servicesList',
            query: {
                title_name: this.categoryList[this.flag].name,
                category: this.categoryList[this.flag].id
            },
      })
    },
    onShow (e) {
      this.flag = e
    },
    //选择六个模块哪一个请求数据来显示
  },
}
</script>

<style scoped>
h1 {
  margin-top: 3.5rem;
  margin-bottom: 2.5rem;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 2.125rem;
  line-height: 3rem;
  align-items: center;
  text-align: center;
  text-transform: capitalize;
  color: #333333;
}
.msg1 {
  padding-top: 0rem;
  width: 9.375rem;
  height: 1.875rem;
  text-align: center;
  color: #ffffff;
}
.msg {
  padding-top: 0.3125rem;
  /* width: 9.375rem; */
  height: 4.625rem;
  text-align: center;
  color: #ffffff;
}

.radio_button :nth-child(1) {
  padding-right: 0.3125rem;
  padding-top: 0.9375rem;
  width: 12.5rem;
  height: 3.125rem;
  align-content: center;
}
.radio_button :nth-child(2) {
  padding-right: 0.3125rem;
  padding-top: 0.9375rem;
  width: 12.5rem;
  height: 3.125rem;
  align-content: center;
}
.radio_button :nth-child(3) {
  padding-top: 0.9375rem;
  width: 12.5rem;
  height: 3.125rem;
  align-content: center;
}
.radio_button :nth-child(4) {
  padding-left: 0.3125rem;
  padding-top: 0.9375rem;
  width: 12.5rem;
  height: 3.125rem;
  align-content: center;
}
.radio_button :nth-child(5) {
  padding-right: 0.3125rem;
  padding-top: 0.9375rem;
  width: 12.5rem;
  height: 3.125rem;
  align-content: center;
}
.radio_button :nth-child(6) {
  padding-right: 0.3125rem;
  padding-top: 0.9375rem;
  width: 12.5rem;
  height: 3.125rem;
  align-content: center;
}
.el-button--primary.is-plain {
  /* background-color: #accdeb; */
  width: 12.625rem;
  height: 6.25rem;
  font-size: 1.5625rem;
}
/deep/ .product {
  background: #accdeb !important;
  display: flex;
  float: left;
  width: 9.625rem;
  height: 5.25rem;
  padding: 0.5rem;
  margin: 0.5rem;
  border-radius: 0.5rem;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 1.5rem;
  line-height: 2.125rem;
  display: flex;
  align-items: center;
  text-align: center;
  text-transform: capitalize;
  text-transform: capitalize;
  justify-content: center;
}
/deep/ .product-select {
  background: #0099da !important;
  float: left;
  width: 9.625rem;
  height: 5.25rem;
  margin: 0.5rem;
  border-radius: 0.5rem;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 1.5rem;
  line-height: 2.125rem;
  display: flex;
  align-items: center;
  text-align: center;
  text-transform: capitalize;
  justify-content: center;
  align-items: center;
}
.top {
  display: flex;
  justify-content: center;
  align-items: center;
}
.font1 {
  width: 43.875rem;
  height: 2.4375rem;
  margin: 0.25rem 1.5rem;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 1.75rem;
  line-height: 2.4375rem;
  text-transform: capitalize;
  color: #333333;
}
.font2 {
  width: 43.875rem;
  height: 2.4375rem;
  margin: 0.25rem 1.5rem;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 1.5rem;
  line-height: 2.125rem;
  color: #333333;
}
.font3 {
  /* width: 6.25rem; */
  height: 1.9375rem;
  margin: 4rem 1.5rem;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 1.375rem;
  line-height: 1.9375rem;
  text-transform: capitalize;
  color: #0099da;
}
.font4 {
  float: right;
  padding-right: 1.5rem;
  margin-right: 3.125rem;
  margin-bottom: 3.75rem;
  margin-top:-6.75rem;
  text-align: center;
}
.font5 {
  float: right;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 1.25rem;
  line-height: 1.75rem;
  /*padding-right: 1.5rem;*/
  /*margin-right: 3.125rem;*/
  color: #0099da;
  text-align: center;
}
</style>
